export default __webpack_public_path__ + "static/media/github.255db585.svg";